import React from 'react';

import { useGetDepartment, useGetLists } from '@vlabs/api/artemy/client';
import type { DepartmentId } from '@vlabs/api/artemy/model';

import {
  AssignListsToAllInDepartmentSwitch,
  DetachDepartmentListIconButton,
} from '@vlabs/monokit/features';

import st from './DepartmentListList.module.sass';
import { DepartmentList } from '../../../entities/lists/@x/departments';
import { FoldableEntityEmpty } from '../../../shared/ui/foldable-entity/FoldableEntityEmpty';

const MAX_PAGE_SIZE = 1000;
interface ViewDepartmentListsProps {
  departmentId: DepartmentId;
}

function ViewDepartmentLists({
  departmentId,
}: ViewDepartmentListsProps): React.JSX.Element {
  const getDepartment = useGetDepartment(departmentId);
  const getLists = useGetLists({ page_size: MAX_PAGE_SIZE, owner_department_ids: [departmentId] });

  const departmentLists = getLists.data?.lists ?? [];
  const lists = getDepartment.data?.lists ?? [];

  const departmentListIds = new Set(
    departmentLists.map(({ list_id }) => list_id),
  );

  const filteredLists = lists.filter(
    ({ list_id }) => !departmentListIds.has(list_id),
  );

  if (filteredLists.length === 0) {
    return <FoldableEntityEmpty />;
  }

  return (
    <React.Fragment>
      {filteredLists.map(({ list_id: listId }) => {
        return listId && (
          <DepartmentList
            actions={(
              <div className={st.Actions}>
                <AssignListsToAllInDepartmentSwitch
                  departmentId={departmentId}
                  listIds={[listId]}
                />
                <DetachDepartmentListIconButton
                  departmentId={departmentId}
                  listIds={[listId]}
                />
              </div>
            )}
            key={listId}
            listId={listId}
          />
        );
      })}
    </React.Fragment>
  );
}

export { ViewDepartmentLists };
